import { Injectable } from '@angular/core';
import { AbstractControlOptions, UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { InvestmentKnowledge } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
import FormGroupArray from '../../services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: InvestmentKnowledge & { riskProfil: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<InvestmentKnowledge & { riskProfil: any }> = {
      ownerId: [entity.ownerId],
      userFirstName: [entity.userFirstName],
      userLastName: [entity.userLastName],
      // knowBond: [entity?.knowBond || null],
      // knowMonetaryProduct: [entity?.knowMonetaryProduct || null],
      // knowPrivateEquity: [entity?.knowPrivateEquity || null],
      // knowScpi: [entity?.knowScpi || null],
      // knowStock: [entity?.knowStock || null],
      // knowIndexFund: [entity?.knowIndexFund || null],
      // knowDerivativeproduct: [entity?.knowDerivativeproduct || null],
      riskProfil: this.formBuilder.group({
        knowBond: [
          !_.isNil(entity?.riskProfil?.knowBond)
            ? entity?.riskProfil?.knowBond
            : false,
        ],
        knowMonetaryProduct: [
          !_.isNil(entity?.riskProfil?.knowMonetaryProduct)
            ? entity?.riskProfil?.knowMonetaryProduct
            : false,
        ],
        knowPrivateEquity: [
          !_.isNil(entity?.riskProfil?.knowPrivateEquity)
            ? entity?.riskProfil?.knowPrivateEquity
            : false,
        ],
        knowScpi: [
          !_.isNil(entity?.riskProfil?.knowScpi)
            ? entity?.riskProfil?.knowScpi
            : false,
        ],
        knowStock: [
          !_.isNil(entity?.riskProfil?.knowStock)
            ? entity?.riskProfil?.knowStock
            : false,
        ],
        knowLifeInsurance: [
          !_.isNil(entity?.riskProfil?.knowLifeInsurance)
            ? entity?.riskProfil?.knowLifeInsurance
            : false,
        ],
        knowDerivativeProducts: [
          !_.isNil(entity?.riskProfil?.knowDerivativeProducts)
            ? entity?.riskProfil?.knowDerivativeProducts
            : false,
        ],
      }),
    };

    return this.formBuilder.group(formConfig);
  }
  generate(entity: InvestmentKnowledge[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
